import React from 'react'
import { useMount } from 'react-nb-hooks'

interface State {
  online: boolean
  offlineAt: Date
}

interface Action {
  type: string
}

const initialState = {
  online: navigator.onLine,
  offlineAt: undefined,
}

function reducer(state: State, action: Action) {
  if (action.type === 'GO_ONLINE') {
    return {
      online: true,
      offlineAt: undefined,
    }
  }

  if (action.type === 'GO_OFFLINE') {
    return {
      online: false,
      offlineAt: new Date(),
    }
  }

  return state
}

export function useNetworkState() {
  const [state, dispatch] = React.useReducer(reducer, initialState)

  useMount(() => {
    function handleOnline() {
      dispatch({ type: 'GO_ONLINE' })
    }

    function handleOffline() {
      dispatch({ type: 'GO_OFFLINE' })
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  })

  return state
}

export const withNetworkState = (Component) => (props) => {
  const { online } = useNetworkState()

  return <Component {...props} isOnline={online} />
}
